import React, { useEffect, useRef, useState } from "react";
import "./questions-builder-content.component.scoped.scss";
import QuestionFormComponent from "../question-form/question-form.component";
import QuestionsListComponent from "../questions-list/questions-list.component";
import { Box } from "@material-ui/core";

const QuestionsBuilderContentComponent = () => {
  const [selectedQuestion, setSelectedQuesion] = useState<any>();
  const formRef = useRef<HTMLDivElement | null>(null);

  const [refreshKey, setRefreshKey] = useState(0);
  const handleQuestionChange = () => {
    setRefreshKey((prev) => prev + 1); // trigger re-fetch in list
  };

  // Scroll to form when selectedQuestion changes
  useEffect(() => {
    if (selectedQuestion && formRef.current) {
      formRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start",
      });
    }
  }, [selectedQuestion]);

  return (
    <div ref={formRef}>
      <Box className="question__builder_content">
        <QuestionFormComponent
          question={selectedQuestion}
          onChangeQuestion={handleQuestionChange}
        />
        <Box className="mt-3">
          <QuestionsListComponent
            key={refreshKey}
            onSelectQuesion={(question: any) => setSelectedQuesion(question)}
          />
        </Box>
      </Box>
    </div>
  );
};

export default QuestionsBuilderContentComponent;
